import { render, staticRenderFns } from "./networks.vue?vue&type=template&id=b5f6d052"
import script from "./networks.vue?vue&type=script&lang=js"
export * from "./networks.vue?vue&type=script&lang=js"
import style0 from "./networks.vue?vue&type=style&index=0&id=b5f6d052&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports